import { Link, useNavigate, useParams } from "react-router-dom";
import { useEnhancedWalletCheckoutMutation, useLazyGetSavedCardQuery, usePayWithWalletMutation, useStripeIntentMutation } from "../../store/payments/paymentsApiSlice";
import { useLazyGetUserProfileQuery } from "../../store/users/usersApiSlice";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useLazyGetMyOrderQuery } from "../../store/orders/orderApiSlice";
import { loadStripe } from "@stripe/stripe-js";
import { toast } from "react-toastify";
import { selectCurrentUserObject } from "../../store/auth/authSlice";
import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../payment/CheckoutForm";
import CustomButton from "../../theme/style-components/CustomButton";
import CustomPaperBox from "../../theme/style-components/CustomPaperBox";
import ComponentTitle from "../../shared/ComponentTitle";
import TabTitle from "../../shared/TabTitle";


const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBKEY
);

const PackagePayment = () => {
    const navigate = useNavigate()
    let { orderID } = useParams();
    const authState = useSelector(state => state.auth)
    const { userType, userID } = authState || {}
    const [stripeIntent, { isLoading }] = useStripeIntentMutation();
    const [payWithWallet, { isLoading: payWithWalletLoading }] = usePayWithWalletMutation();
    const [enhancedWalletCheckout, { isLoading: enhanceWalletLoading }] = useEnhancedWalletCheckoutMutation();
    const [getSavedCard, { isLoading: isSavedCardLoading, data }] = useLazyGetSavedCardQuery();
    const [getUserProfile] = useLazyGetUserProfileQuery();
    // const savedCardsData = data?.data

    //state variables
    const [flag, setFlag] = useState(false);
    const [message, setMessage] = useState("");
    const [key, setKey] = useState("");
    const [paymentFlag, setPaymentFlag] = useState(false);
    const [showNewCard, setShowNewCard] = useState(false);
    const [savedCardsData, setSavedCardsData] = useState([])
    const [savedCardsDetails, setSavedCardsDetails] = useState("");
    const [isSubscription, setIsSubscription] = useState(false);
    const [saveCardLoading, setSaveCardLoading] = useState(false);
    const [cardIntentLoading, setCardIntentLoading] = useState(false);
    const [cardIntentError, setCardIntentError] = useState("");
    const [subscriptionPharma, setSubscriptionPharma] = useState('');
    const [getMyOrder, { isLoading: isGetMyOrderLoading }] = useLazyGetMyOrderQuery();
    const [orderAmount, setOrderAmount] =useState()
    const [availableCreditAmount, setAvailableCreditAmount] =useState()

    const remainingAmount = (availableCreditAmount - orderAmount).toFixed(2)

    //stripe options
    const [options, setOptions] = useState({
        clientSecret: "",
    });

    let user = useSelector(selectCurrentUserObject);

    useEffect(() => {
        const fetchSavedCard = async () => {
            try {
                const response = await getSavedCard(userID).unwrap().then((res) => {
                    if (res?.data) {
                        setSavedCardsData(res?.data)
                        setSavedCardsDetails({ order_id: orderID, payment_method_key: res?.data[0]?.id })
                        if (!res?.data?.length) {
                            setShowNewCard(false)
                        }
                    }
                })
            } catch (err) {
                console.log(err);
            }
        }

        if (userID) {
            fetchSavedCard()
        }
    }, [userID]);

    useEffect(() => {
        const payment = async () => {
            try {
                setCardIntentLoading(true);
                setCardIntentError("");
                setOptions({ clientSecret: "" });
                let response = await stripeIntent({
                    order_id: Number(orderID),
                }).unwrap();
                let successMessage = "";

                if (!response.data.skip) {
                    setPaymentFlag(true);
                    successMessage += "Secret Key: ";
                    successMessage += response.data.clientSecret;
                }
                else {
                    // setPaymentFlag(false);
                    successMessage += 'Custom Invoice is set. Skipping Stripe.';
                    toast.success("skipping the stripe payment: custom invoice enabled", {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    if (userType === "ADMIN") {
                        navigate("/orders")
                    } else {
                        navigate("/myorders")
                    }
                }
                setOptions({
                    clientSecret: response.data.clientSecret,
                });
                setMessage(successMessage);
            } catch (error) {
                console.log(error, "error");
                // let errorMessage = "";
                // errorMessage += error.data.message && error.data.message;
                // errorMessage += " ";
                const errorMessage = error.data && error.data.message;
                setMessage(errorMessage);
                toast.error(errorMessage, {
                    position: toast.POSITION.TOP_RIGHT
                });
                if (userType === "ADMIN") {
                    navigate("/orders")
                } else {
                    navigate("/myorders")
                }
            }
        };
        if (!flag) {
            // payment(orderID);
            setFlag(true);
        }
    }, []);

    const [isCustomInvoice, setIsCustomInvoice] = useState(false);

    useEffect(() => {

        const fetchMyOrder = async () => {
            try {
                const result = await getMyOrder({ page: 1, query: `&order_id=${orderID}` }).unwrap().then((res) => {
                    if (res?.data[0]) {
                        const subscription = res?.data[0]?.subscription?.name
                        setSubscriptionPharma(subscription)
                        setOrderAmount((res?.data[0]?.quote_distribution?.total_charge_amount / 100).toFixed(2))
                        setAvailableCreditAmount((res?.data[0]?.available_credit/100).toFixed(2))
                        if (subscription) {
                            setIsSubscription(true)
                        }
                        if (res?.data[0].merchant_address_details.is_custom_invoice === true) {
                            setIsCustomInvoice(true);
                        };
                    };
                });
            } catch (error) {
                toast.error(`Something went wrong!!`, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }

        if (userType === "MERCHANT") {
            fetchMyOrder()
        }

    }, [userType, isCustomInvoice, isSubscription])


    useEffect(() => {
        const payment = async () => {
            try {
                let response = await stripeIntent({
                    order_id: Number(orderID),
                }).unwrap();
                let successMessage = "";

                if (!response.data.skip) {
                    setPaymentFlag(true);
                    successMessage += "Secret Key: ";
                    successMessage += response.data.clientSecret;
                }
                else {
                    // setPaymentFlag(false);
                    successMessage += 'Custom Invoice is set. Skipping Stripe.';
                    toast.success("skipping the stripe payment: custom invoice enabled", {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    if (userType === "ADMIN") {
                        navigate("/orders")
                    } else {
                        navigate("/myorders")
                    }
                }

                setOptions({
                    clientSecret: response.data.clientSecret,
                });
                setMessage(successMessage);
                setCardIntentLoading(false);
            } catch (error) {
                console.log(error, "error");
                const errorMessage = (error.data && error.data.message) || "Unable to load card form. Please try again.";
                setMessage(errorMessage);
                setCardIntentError(errorMessage);
                setCardIntentLoading(false);
                toast.error(errorMessage, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        };
        if (showNewCard) {
            payment(orderID);
            // setFlag(true);
        };
    }, [showNewCard]);

    const callSavedStripe = async () => {
        try {
            setSaveCardLoading(true)
            const response = await stripeIntent(savedCardsDetails).unwrap().then((res) => {
                setSaveCardLoading(false)
                res && toast.success("paid successfully!", {
                    position: toast.POSITION.TOP_RIGHT
                });
                if (userType === "ADMIN") {
                    navigate("/orders")
                } else {
                    navigate("/my-orders")
                }
            });
        } catch (err) {
            console.log(err);
        }
    }

    const handleWalletPay = async (e) => {
        try {
          let response;
      
          if (subscriptionPharma === "Pharmachain") {
            response = await enhancedWalletCheckout({ order_id: Number(orderID) }).unwrap();
          } else {
            response = await payWithWallet({ order_id: Number(orderID) }).unwrap();
          }
      
          if (response) {
            toast.success(response.message, { position: toast.POSITION.TOP_RIGHT });
      
            if (userType === "ADMIN") {
              navigate("/orders");
            } else {
              navigate("/my-orders");
            }
          }
        } catch (err) {
          let errorMessage = "";
      
          if (err?.data?.errors) {
            for (const key in err.data.errors) {
              if (Array.isArray(err.data.errors[key]) && err.data.errors[key].length > 0) {
                errorMessage = err.data.errors[key][0];
                break;
              }
            }
          }
      
          if (!errorMessage && err?.data?.message) {
            errorMessage = err.data.message;
          }
      
          if (errorMessage) {
            toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT });
          } else {
            toast.error("Something went wrong.", { position: toast.POSITION.TOP_RIGHT });
          }
        }
      };
      

    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                const response = await getUserProfile()
                    .unwrap()
                    .then((res) => {
                        console.log("refresh the balance");
                    })
            } catch (err) {
                console.log(err);
            }
        }

        fetchUserProfile()
    }, []);

    const handleRechargeClick = (e) => {
        navigate("/recharge");
    };

    const breadcrumbs = [
        <Link key="1" to={userType === "ADMIN" ? "/orders" : "/my-orders"}>
            {userType === "ADMIN" ? "Orders" : "My Orders"}
        </Link>,
        <Typography key="2" variant="body1">
            Payment
        </Typography>,
    ];

    return (
        <>
            {/* {!isSubscription && */}
            {
                subscriptionPharma === "Pharmachain" ? (<>
                    <Box>
                    <ComponentTitle breadcrumbs={breadcrumbs} />
                    {parseInt(availableCreditAmount) < parseInt(orderAmount) && (
                         <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%",padding:"20px 0" }}>
                                    <Box sx={{ 
                                        backgroundColor: '#FF5E9126', 
                                        padding: '15px', 
                                        borderRadius: '8px', 
                                        margin: '15px 0',
                                        display: 'grid',
                                        width: "100%", maxWidth: "515px", height: "auto",
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}>
                                        <Typography sx={{ color: '#FF5E91', fontSize: '16px', fontWeight: '500', textAlign: 'center' }}>
                                            Your wallet balance is low. Please top up to continue.
                                        </Typography>
                                        <Box sx={{ textAlign: "center", marginTop: "18px" }}>
                                        <CustomButton
                                            color="primary"
                                            onClick={handleRechargeClick}
                                            buttonName="Top Up Wallet"
                                            sx={{ 
                                                backgroundColor: '#FF5E91',
                                                '&:hover': {
                                                    backgroundColor: '#FF5E91CC'
                                                },
                                                borderRadius: "10px",
                                                fontFamily: "Quicksand, sans-serif"
                                            }}
                                        />
                                        </Box>
                                    </Box>
                                    </Box>
                                )}

                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%",padding:"20px 0" }}>
                            <Box sx={{ padding: "20px", backgroundColor: "#2B2C40", borderRadius: "10px", width: "100%", maxWidth: "515px", height: "auto" }}>
                                <Typography variant="h5" sx={{ fontSize: "18px", fontWeight: "700", paddingBottom: "30px", color: "#FFFFFFCC", textAlign: "center", fontFamily: "Quicksand, sans-serif"}}>Subscription Name: {subscriptionPharma}</Typography>
                                <Box sx={{ padding: "18px 0", borderTop: "1px solid #9797A926", borderBottom: "1px solid #9797A926", display: "flex", justifyContent: "space-between" }}>
                                    <Typography variant="h6" sx={{ fontSize: "18px", fontWeight: "500", color: "#FFFFFFCC",fontFamily: "Quicksand, sans-serif" }}>
                                        Available Credits
                                    </Typography>
                                    <Typography component="p" sx={{ fontSize: "18px", fontWeight: "700", color: "#1BC2FF",fontFamily: "Quicksand, sans-serif" }}>AUD {availableCreditAmount}</Typography>
                                </Box>
                                <Box sx={{ padding: "18px 0", borderBottom: "1px solid #9797A926", display: "flex", justifyContent: "space-between" }}>
                                    <Typography variant="h5" sx={{ fontSize: "18px", fontWeight: "500", color: "#FFFFFFCC", textAlign: "center",fontFamily: "Quicksand, sans-serif" }}>
                                        Order Amount
                                    </Typography>
                                    <Typography component="p" sx={{ fontSize: "18px", fontWeight: "700", color: "#FF5E91",fontFamily: "Quicksand, sans-serif" }}>
                                        AUD {orderAmount}
                                    </Typography>
                                </Box>
                                <Box sx={{ padding: "18px 0", borderBottom: "1px solid #9797A926", textAlign: "center" }}>
                                    <Typography component="p" sx={{ fontSize: { xs: "16px", sm: "18px" }, fontWeight: "500", color: "#1BC2FF",fontFamily: "Quicksand, sans-serif" }}>
                                        Remaining Wallet Balance : <span style={{ fontSize: "18px", fontWeight: "700", color: "#1BC2FF" }}>AUD {remainingAmount}</span> </Typography>
                                </Box>
                                <Box sx={{ textAlign: "center", marginTop: "18px" }}>
                                    <CustomButton
                                        color="primary"
                                        onClick={handleWalletPay}
                                        buttonName="Submit Order"
                                        disabled={parseInt(availableCreditAmount) < parseInt(orderAmount)}
                                        sx={{ borderRadius: "10px",fontFamily: "Quicksand, sans-serif" }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </>) : (
                    <Box>
                        <TabTitle title="Package Payment" />
                        <ComponentTitle breadcrumbs={breadcrumbs} />

                        <CustomPaperBox>
                            <Grid container spacing={2} >
                                {!isCustomInvoice && showNewCard ?
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <Box sx={{
                                            width: "100%",
                                            maxWidth: "50%",
                                            margin: "0 auto"
                                        }}>
                                            <Typography sx={{ color: "#dbdbebde" }} variant="h4">New Card</Typography>
                                            {cardIntentLoading ? (
                                                <Typography sx={{ mt: 2 }}>Loading card form...</Typography>
                                            ) : options?.clientSecret ? (
                                                <Elements stripe={stripePromise} options={options}>
                                                    <CheckoutForm />
                                                </Elements>
                                            ) : (
                                                <Typography sx={{ mt: 2, color: "#dbdbebde" }}>
                                                    {cardIntentError || "Unable to load card form. Please go back and try again."}
                                                </Typography>
                                            )}
                                        </Box>
                                        <Box sx={{
                                            textAlign: "center"
                                        }}>
                                            <CustomButton
                                                color="secondary"
                                                type="submit"
                                                buttonName="Back"
                                                onClick={() => {
                                                    setShowNewCard(false);
                                                    setCardIntentError("");
                                                }}
                                            /></Box>
                                    </Grid>
                                    : isSavedCardLoading ? <Grid item lg={12} md={12} sm={12} xs={12}><Box sx={{
                                        width: '100%',
                                        maxWidth: "50%",
                                        margin: '0 auto',
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>Loading...</Box> </Grid> :
                                        <>
                                            {userType !== "ADMIN" && !isCustomInvoice && <Box sx={{
                                                width: "100%",
                                                maxWidth: "50%",
                                                margin: "0 auto",
                                                display: "flex",
                                                justifyContent: "center",
                                                gap: "10px",
                                                alignItems: "center",
                                                marginTop: "20px"
                                            }}>

                                                <Typography style={{
                                                    display: "flex",
                                                    marginRight: "auto",
                                                }}>Available Balance: {
                                                        user?.wallet_balance_cents === 0 || user?.wallet_balance_cents ?
                                                            <Typography style={{
                                                                fontWeight: "500",
                                                                marginLeft: "10px"
                                                            }}>$ {user?.wallet_balance_cents / 100}</Typography> : <CircularProgress size={20} />
                                                    }
                                                </Typography>
                                                <CustomButton
                                                    color="primary"
                                                    onClick={handleWalletPay}
                                                    disabled={payWithWalletLoading}
                                                    isLoading={payWithWalletLoading}
                                                    buttonName="Pay With Wallet"
                                                />
                                                {/* {isSubscription &&
                                                    <CustomButton
                                                        color="primary"
                                                        onClick={handleRechargeClick}
                                                        disabled={isGetMyOrderLoading}
                                                        isLoading={isGetMyOrderLoading}
                                                        buttonName="Recharge"
                                                    />
                                                } */}
                                            </Box>
                                            }
                                            {userType !== "ADMIN" && !isGetMyOrderLoading && !isCustomInvoice && savedCardsData?.length !== 0 && <Grid item lg={12} md={12} sm={12} xs={12}>
                                                <Box sx={{
                                                    width: "100%",
                                                    maxWidth: "50%",
                                                    margin: "0 auto"
                                                }}>
                                                    <Typography variant="h4">Saved Card</Typography>
                                                    {isSavedCardLoading ? <Box>Loading...</Box> :
                                                        <Box>
                                                            {savedCardsData.map((card) => {
                                                                return (
                                                                    <Box sx={{
                                                                        border: savedCardsDetails.payment_method_key === card?.id ? '1px solid #696cff' : "1px solid #dbdbeb4f",
                                                                        borderRadius: '5px',
                                                                        padding: '5px 10px',
                                                                        marginBottom: '10px',
                                                                        cursor: "pointer"
                                                                    }}
                                                                        onClick={() => setSavedCardsDetails({ order_id: orderID, payment_method_key: card?.id })}>
                                                                        <Typography variant='p'>**** **** **** {card?.card?.last4}</Typography>
                                                                        <Typography>{card?.card?.brand}</Typography>
                                                                    </Box>
                                                                );
                                                            })}
                                                            <Box sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}>
                                                                <CustomButton
                                                                    color="primary"
                                                                    type="submit"
                                                                    disabled={saveCardLoading}
                                                                    isLoading={saveCardLoading}
                                                                    onClick={() => callSavedStripe()}
                                                                    buttonName="Submit"
                                                                />
                                                            </Box>
                                                        </Box>
                                                    }
                                                </Box>
                                            </Grid>}
                                        </>
                                        
                                }
                                {!showNewCard && !isGetMyOrderLoading && <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Box sx={{
                                        textAlign: "center"
                                    }}><CustomButton
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            style={{
                                                textTransform: "capitalize",
                                                minWidth: "120px",
                                                backgroundColor: "rgb(19, 148, 255)",
                                                color: "rgb(255, 255, 255)",
                                                borderRadius: "20px",
                                                marginTop: "10px",
                                            }}
                                            onClick={() => setShowNewCard(true)}
                                            buttonName={userType === "ADMIN" || isCustomInvoice ? "Skip Payment" : "Add New Card"}
                                        /></Box>
                                </Grid>}
                            </Grid>
                        </CustomPaperBox>
                    </Box>
                )
            }
            {/* // } */}
            {/* {isSubscription &&
                <SubscriptionFredit availableBalance={user?.wallet_balance_cents / 100} />} */}
            </>
    );
};

export default PackagePayment;
